
  $(document).ready(function() {
    $('.package_image_section').slick({
      slidesToShow: 1, // Mobile view (below 768px)
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: true,
      infinite:true,
      responsive: [
        {
          breakpoint: 1366,
          settings: {
            slidesToShow: 1, // Desktop view (768px and above)
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 1, // Desktop view (768px and above)
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1,
          settings: {
            slidesToShow: 3, // Desktop view (768px and above)
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1, // Desktop view (768px and above)
            slidesToScroll: 1
          }
        },
        {
        breakpoint: 575,
          settings: {
            slidesToShow: 1, // Desktop view (768px and above)
            slidesToScroll: 1
          }
        }
      ]
    });
  });
  
